var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "schedule-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        {
          staticClass: "filter-card",
          attrs: { shadow: "never", "body-style": { padding: "18px 22px" } },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "项目搜索" } },
                [
                  _c("el-input", {
                    staticClass: "search",
                    attrs: {
                      clearable: "",
                      placeholder: "项目 / 客户 / 手机 / 小区",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "项目状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部状态" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.projectStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "projectStatus", $$v)
                        },
                        expression: "searchForm.projectStatus",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "施工中", value: "in_progress" },
                      }),
                      _c("el-option", {
                        attrs: { label: "验收中", value: "acceptance" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已完工", value: "completed" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.overdue,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "overdue", $$v)
                        },
                        expression: "searchForm.overdue",
                      },
                    },
                    [_vm._v("只看超时")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "metrics" }, [
        _c("div", [
          _c("span", [_vm._v("项目总数")]),
          _c("strong", [_vm._v(_vm._s(_vm.tableData.total))]),
          _c("small", [_vm._v("PROJECTS")]),
        ]),
        _c("div", [
          _c("span", [_vm._v("当前页节点")]),
          _c("strong", [_vm._v(_vm._s(_vm.nodeTotal))]),
          _c("small", [_vm._v("NODES")]),
        ]),
        _c("div", { staticClass: "success" }, [
          _c("span", [_vm._v("已完成节点")]),
          _c("strong", [_vm._v(_vm._s(_vm.completedTotal))]),
          _c("small", [_vm._v("COMPLETED")]),
        ]),
        _c("div", { class: _vm.overdueTotal ? "danger" : "" }, [
          _c("span", [_vm._v("超时节点")]),
          _c("strong", [_vm._v(_vm._s(_vm.overdueTotal))]),
          _c("small", [_vm._v("OVERDUE")]),
        ]),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c("div", [
                _c("strong", [_vm._v("项目工期台账")]),
                _c("span", [_vm._v("点击展开查看完整 WBS 节点")]),
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", icon: "el-icon-refresh" },
                  on: { click: _vm.getList },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "node-list" },
                          _vm._l(row.schedules, function (node, index) {
                            return _c(
                              "div",
                              {
                                key: node.id,
                                class: [
                                  "node",
                                  node.status,
                                  node.overdue ? "overdue" : "",
                                ],
                              },
                              [
                                _c("div", { staticClass: "index" }, [
                                  _vm._v(
                                    _vm._s(
                                      node.status === "completed"
                                        ? "✓"
                                        : index + 1
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "node-main" }, [
                                  _c("strong", [_vm._v(_vm._s(node.nodeName))]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.typeText[node.nodeType] ||
                                          node.nodeType
                                      ) +
                                        " · " +
                                        _vm._s(node.ownerName || "待配置负责人")
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "node-plan" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.date(node.plannedStartTime)
                                        ) +
                                          " 至 " +
                                          _vm._s(_vm.date(node.plannedEndTime))
                                      ),
                                    ]),
                                    _c("el-progress", {
                                      attrs: {
                                        percentage: Number(
                                          node.progressPercent || 0
                                        ),
                                        "stroke-width": 6,
                                        "show-text": false,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: node.overdue
                                        ? "danger"
                                        : node.status === "completed"
                                        ? "success"
                                        : node.status === "in_progress"
                                        ? "warning"
                                        : "info",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        node.overdue
                                          ? "已超时"
                                          : _vm.statusText[node.status] ||
                                              node.status
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "项目编号", "min-width": "205" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", { staticClass: "project-no" }, [
                          _vm._v(_vm._s(row.project.projectNo)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "工地项目", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "two-line" }, [
                          _c("strong", [
                            _vm._v(_vm._s(row.project.projectName)),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(row.property.communityName)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "客户", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "two-line" }, [
                          _c("strong", [_vm._v(_vm._s(row.lead.name))]),
                          _c("span", [_vm._v(_vm._s(row.lead.mobile))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "计划周期", "min-width": "205" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(row.project.plannedStartDate) +
                            " 至 " +
                            _vm._s(row.project.plannedEndDate)
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "整体进度", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "progress-cell" },
                          [
                            _c("el-progress", {
                              attrs: {
                                percentage: Number(row.overallProgress || 0),
                                "stroke-width": 8,
                              },
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(row.completedCount) +
                                  "/" +
                                  _vm._s(row.totalCount) +
                                  " 节点"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "超时", "min-width": "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: row.overdueCount ? "danger" : "success",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                row.overdueCount
                                  ? row.overdueCount + " 个"
                                  : "正常"
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "当前节点", "min-width": "145" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.currentNode(row)))]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("CONSTRUCTION CONTROL")]),
        _c("h2", [_vm._v("施工工期控制台")]),
        _c("p", [_vm._v("统一查看节点计划、责任人、完成进度与施工超时。")]),
      ]),
      _c("div", { staticClass: "hero-legend" }, [
        _c("i", { staticClass: "normal" }),
        _vm._v(" 正常推进 "),
        _c("i", { staticClass: "risk" }),
        _vm._v(" 超时预警"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }